// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"3d00b7370d5b3556","5285":"73b4a355404c2aa9"}[chunkId] + ".css";
};